import { FC } from 'react';
import { useRouter } from 'next/router';
import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';
import { useDP3Store } from '../../DP3Provider';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { signupCookie } from '@/utils/cookies/signupCookie';

const WARM_UP_US = () => (
    <div className="terms-list terms-warm-up">
        <ol className="ol-number">
            <li>
                <strong>Timeline</strong>
                <p>
                    The EcoFlow DELTA Pro 3 product campaign runs from June 11, 2024 to July 23, 2024 PST, with the official launch date being June 24, 8 PM
                    PST.
                </p>
            </li>
            <li>
                <strong>Early Bird Subscription</strong>
                <p>
                    To receive the latest information about EcoFlow DELTA Pro 3, you can enter your email address on the new product page between June 11 and
                    June 24 PST. By doing so, you agree to our email marketing terms and conditions and subscribe to our marketing emails for notifications.
                </p>
            </li>
            <li>
                <strong>Benefits</strong>
                <p>During the promotion period (June 11, 2024 to June 24, 2024 PST), you will get the following benefits by subscribing:</p>
                <ol className="ol-char">
                    <li>
                        Benefit 1: During the official launch period (June 24, 2024 to July 23, 2024 PST), you will get a $500 coupon{' '}
                        <strong>code: DP3LAUNCH</strong> that is only available for DELTA Pro 3 portable power station stand-alone unit and enjoy the discount
                        by applying the coupon at checkout. Only one code can be applied to one transaction.
                    </li>
                    <li>
                        Benefit 2: During the official launch period (June 24, 2024 to July 23, 2024 PST), when you purchase a DELTA Pro 3 + 400W solar panel
                        bundle, we will only charge you for the price of the DELTA Pro 3, and the 400W solar panel will be included for free.
                    </li>
                    <li>
                        Benefit 3: During the official launch period (June 24, 2024 to July 23 2024 PST), you will get an extra $300 off discount on DELTA Pro 3
                        + DELTA Pro 3 Extra Battery, DELTA Pro 3+ Smart Home Panel 2 bundle or DELTA Pro 3 + Smart Generator 4000 (Dual Fuel) bundle
                        respectively, by checking out at a discounted price.
                    </li>
                </ol>
                <p>*Only one code can be applied to one transaction. These Benefits cannot combined with other discounts.</p>
                <p>*Please keep the coupon information confidential and do not share the coupon with others.</p>
                <p>
                    *EcoFlow reserves the right to cancel the coupon and any associated orders at any time in cases of dishonesty, fraud, or any violation of
                    these terms.
                </p>
            </li>
            <li>
                <strong>Upgraded Financing Option</strong>
                <p>
                    During June 24, 2024 to August 31, 2024 PST, orders with DELTA Pro 3 portable power station and the related bundles will get a 24-month
                    interest-free financing at 0% APR when you pay with Affirm.
                </p>
            </li>
            <li>
                <strong>Extended warranty service</strong>
                <p>
                    During the official launch period (June 24, 2024 to July 23, 2024 PST), when you purchase and successfully pay for the order of DELTA Pro 3
                    and related bundles, you will get a 7-year free warranty: 5 years standard warranty plus an additional 2 years extended warranty.
                </p>
                <p>*This extended warranty is only valid on DELTA Pro 3 and DELTA Pro 3-related bundles.</p>
            </li>
            <li>
                The Sale is open to all users on{' '}
                <a href="https://us.ecoflow.com/" target="_blank" rel="noreferrer">
                    us.ecoflow.com
                </a>{' '}
                who are US citizens or residents and (i) at least 18 years of age or (ii) legal age before June 11, 2024 PST to form a binding contract with
                EcoFlow.
            </li>
            <li>
                Free gifts cannot be redeemed for cash or discounts. The free gifts are non-stackable, non-transferable, non-replaceable, non-discountable,
                non-selectable and non-upgradeable.
            </li>
            <li>Orders placed during the EcoFlow DELTA Pro 3 product campaign are refunded subject to the actual amount paid.</li>
            <li>When users request a refund of an order with free gifts, the gifts must be returned together. Otherwise, the refund can not be processed.</li>
            <li>
                You can cancel your order before shipping for a refund. Click{' '}
                <a href="https://us.ecoflow.com/pages/ecoflow-return-policy" target="_blank" rel="noreferrer">
                    here
                </a>{' '}
                for details about return and refund policies.
            </li>
            <li>
                Participants agree to release and discharge EcoFlow from any liabilities and claims, including breach of contract, tort, negligence, or any
                other cause of action at law or equity, arising out of, or in any way connected to this campaign or the participant's entry into the campaign.
            </li>
            <li>
                Participants further agree to release and discharge any third party related to or connected with this campaign from any liabilities and claims,
                including breach of contract, tort, negligence, or any other cause of action at law or equity arising out of, or in any way connected to this
                campaign, or the participant's entry into the campaign.
            </li>
            <li>
                By participating in this campaign, participants agree to indemnify and hold EcoFlow and the EcoFlow Group of Companies, their officers,
                directors, shareholders, predecessors, successors, employees, agents, and representatives harmless from any claims, losses, damages,
                liabilities, or expenses (including legal fees) arising from this campaign or related to it in any way.
            </li>
            <li>
                EcoFlow reserves the right to disqualify participants who use or have used improper means to participate in this campaign without prior notice
                and may initiate legal proceedings to the fullest extent permitted by applicable law.
            </li>
            <li>
                EcoFlow reserves the right to modify, adjust, or terminate this campaign, with any changes, adjustments, or terminations being announced on the
                online sales platform.
            </li>
            <li>
                Geographical Restrictions: This program is exclusive to the EcoFlow US Online Store (
                <a href="https://us.ecoflow.com/" target="_blank" rel="noreferrer">
                    us.ecoflow.com
                </a>
                ).
            </li>
            <li>Separate Packaging: Products are shipped separately for safe delivery.</li>
            <li>
                Free shipping is unavailable for outlying areas, including Guam, Puerto Rico, Hawaii, and Alaska. Please refer to our shipping policy for more
                details.
            </li>
            <li>
                If you have any questions, please contact customer service{' '}
                <a href="mailto:support@ecoflow.com" target="_blank" rel="noreferrer">
                    support@ecoflow.com
                </a>{' '}
                for assistance.
            </li>
            <li>This campaign and its terms and conditions are governed by the laws of the country where it is held.</li>
        </ol>
        <strong>Installation Consulting Service Terms and Conditions</strong>
        <ol className="ol-number">
            <li>
                <strong>Installation Conditions</strong>
                <ol className="ol-char">
                    <li>The Installation Consultation Package is issued upon the purchase of the EcoFlow Smart Home Panel 2 or Smart Home Panel 2 bundle.</li>
                    <li>
                        If a customer fails to fill out the installation information collection form sent via email by EcoFlow within 7 days of receiving such
                        email, rendering EcoFlow unable to collect information for matching electrician resources, it will be deemed that such customer does not
                        require installation/consultation services.
                    </li>
                </ol>
            </li>
            <li>
                <strong>Description of the Installation Consultation Package</strong>
                <ol className="ol-char">
                    <li>
                        In line with the promotion of EcoFlow Smart Home Panel 2 on the US EcoFlow official website (
                        <a href="https://www.ecoflow.com/us" target="_blank" rel="noreferrer">
                            https://www.ecoflow.com/us
                        </a>
                        ), EcoFlow will refer installation resources to customers who have placed orders and assist them in scheduling installation appointments
                        with electricians.
                    </li>
                    <li>
                        Installation consultation service includes wiring the EcoFlow Smart Home Panel 2 to the existing load center. It does not include wiring
                        the EcoFlow Power Station to solar panels or PV systems. If the customer requires the installation to include wiring to solar panels or
                        PV systems, the electrician reserves the right to refuse to take order.
                    </li>
                    <li>The rebate is not applicable to the Hassel Free Kit.</li>
                    <li>
                        Information security related terms. The user's personal information is authorized by the user, and EcoFlow will not be held responsible
                        for any misuse of the user's information by electricians.
                    </li>
                </ol>
            </li>
            <li>
                <strong>Risk Statement of the Installation Consultation Package</strong>
                <ol className="ol-char">
                    <li>
                        Installation by an electrician represents a commercial contract arrangement with contractual responsibilities exclusively between users
                        and electrician, exclusive of any contract or other responsibility of EcoFlow. Electrician assumes sole responsibility for its pricing
                        standards. EcoFlow shall be not liable for any of the consequences of electrician’s installation services.
                    </li>
                    <li>
                        There is a risk that the electrician will refuse to take orders in the current consultation and booking process.
                        <ol className="ol-lower-roman">
                            <li>
                                If, after purchasing an EcoFlow product, an electrician’s assessment concludes that the customer’s house condition does not
                                permit installation of EcoFlow Smart Home Panel 2 and a return is required, the cost incurred for the electrician’s on-site
                                assessment shall be borne by the customer.
                            </li>
                            <li>Modifications to Existing Rooftop Solar Systems Connections</li>
                            <li>
                                Home circuits that have been modified by customers without applying for applicable permissions from the government will not
                                satisfy EcoFlow products’ installation conditions.
                            </li>
                            <li>
                                If a customer’s house is too large, which results in long wiring and rendering voltage value too low, there may be a risk that
                                the NEC regulations will not be satisfied, and installations will be unrealizable.
                            </li>
                            <li>Other circumstances that make installation impossible.</li>
                            <li>
                                EcoFlow will not be liable for any loss of personal property caused by voluntary installation by a customer if the above
                                installation conditions are not satisfied, and EcoFlow reserves the right of final interpretation.
                            </li>
                            <li>
                                The installation service does not include any cleaning or removal of debris generated during the installation process. Residents
                                are responsible for managing and disposing of all trash and debris resulting from the installation.
                            </li>
                            <li>
                                Any holes or modifications made to the premises during the installation are considered normal and necessary for the proper
                                completion of the service. The installer shall not be held liable for any unavoidable damages or alterations made to the
                                premises during the installation process.
                            </li>
                            <li>
                                Any additional costs arising from the need for extra materials or labor due to a complex installation environment shall be the
                                responsibility of the resident. These costs must be settled by the resident when completing the installation.
                            </li>
                            <li>
                                Any product issues or defects resulting from installation by an unauthorized installer shall be the sole responsibility of the
                                resident. The resident shall bear full responsibility for any after-sales service or repairs needed due to such unauthorized
                                installations.
                            </li>
                            <li>Privacy Protection</li>
                        </ol>
                        EcoFlow is only responsible for the user's personal information that we collect. EcoFlow is not responsible for any personal information
                        that the user authorizes to be given to electricians and shall not be held responsible for any misuse of the user's information by
                        electricians. To know more about your privacy rights and how EcoFlow handles your personal information, please view our{' '}
                        <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank" rel="noreferrer">
                            Privacy Policy.
                        </a>
                    </li>
                </ol>
            </li>
        </ol>
        <strong>EcoFlow Smart Home Panel 2 (or Smart Home Panel 2 bundle) + Installation fee Installation Terms & Conditions</strong>
        <ol className="ol-number">
            <li>
                <strong>Installation Conditions</strong>
                <ol className="ol-char">
                    <li>
                        Home circuits that have been modified by customers without permission from the government will not meet the installation conditions.
                    </li>
                    <li>
                        If a customer's house is too large, resulting in excessive wiring and undervoltage, there may be a risk that the NEC regulations will
                        not be met, and the installation will be prevented.
                    </li>
                    <li>
                        In the event of unforeseen circumstances that may prevent installation, EcoFlow reserves the right to determine the final feasibility of
                        installation.
                    </li>
                    <li>
                        <strong>Description of the Installation Service Package</strong>
                        <ol className="ol-lower-roman">
                            <li>
                                To support sales of Smart Home Panel 2 or Smart Home Panel 2 bundle in North America through the EcoFlow US official website,
                                EcoFlow offers an installation service package, which includes the basic installation cost for Smart Home Panel 2.
                            </li>
                            <li>
                                Customers who purchase EcoFlow Smart Home Panel 2 or EcoFlow Smart Home Panel 2 bundle through Shopify may opt to purchase the
                                "Installation service Package" (limited to addresses in California, Texas, Florida, Washington, Illinois, Wisconsin, Minnesota,
                                Colorado, Indiana, Georgia, Nevada, Arizona, Michigan, Pennsylvania and NYC only). EcoFlow customer service is responsible for
                                matching the customers with electricians who can take the order and for following up on the progress of the installation.
                            </li>
                            <li>
                                Installation Service Package includes wiring the EcoFlow Smart Home Panel 2 to the existing load center. It does not include
                                wiring the EcoFlow Power Station to solar panels or PV systems. If the customer requires the installation to include wiring to
                                solar panels or PV systems, the electrician reserves the right to refuse to take the order. The installation service fee on the
                                official website covers labor costs and the materials needed for installing Smart Home Panel 2 within 2 feet of the load center.
                                This excludes:
                                <ol className="ol-number">
                                    <li>
                                        Additional material and labor costs due to excessive distance or incompatibility between the existing circuit breaker
                                        and Smart Home Panel 2.
                                    </li>
                                    <li>Permit application fees are incurred under applicable laws and regulations in certain areas.</li>
                                    <li>
                                        The electrician's on-site assessment fee can be waived if the circumstance has been assessed by the electrician to be
                                        suitable for installation and the customer does not request a refund of the installation service fee.
                                    </li>
                                </ol>
                                The above extra costs and fees shall be subject to the actual quote from the electrician. Customers are responsible for directly
                                paying the electrician for any extra costs incurred. EcoFlow reserves the right to final interpretation of the installation
                                service fee.
                            </li>
                            <li>
                                By agreeing to EcoFlow's installation services, you consent to the collection and processing of personal information necessary
                                for completing the service. This may include but is not limited to, your name, address, contact information, and any relevant
                                details related to the installation. We will handle your personal information in compliance with applicable data protection laws
                                and regulations and will only use it for the purpose of fulfilling the installation service. Please refrain from directly
                                providing your personal information to the electrician during the installation process, otherwise you will be responsible for
                                any loss or damage caused by the disclosure of such information.
                            </li>
                        </ol>
                    </li>
                </ol>
            </li>
            <li>
                <strong>Risk Statement of the Installation Service Package</strong>
                <ol className="ol-char">
                    <li>The option for the installation service package is based on the purchase of Smart Home Panel 2.</li>
                    <li>
                        If, after purchasing Smart Home Panel 2, it is concluded through the electrician's assessment that the customer's home situation does
                        not allow for installation of Smart Home Panel 2 and a return of Smart Home Panel 2 is necessary, the cost incurred for the
                        electrician's on-site assessment will be borne by the customer.
                    </li>
                    <li>
                        Should a customer opt for our installation service and then decide to return the Smart Home Panel 2 due to dissatisfaction after
                        installation, the paid installation fee cannot be refunded. Additionally, the customer will be responsible for any costs associated with
                        the removal of Smart Home Panel 2.
                    </li>
                </ol>
            </li>
        </ol>
    </div>
);
const WARM_UP_CA = () => (
    <div className="terms-list terms-warm-up">
        <ol className="ol-number">
            <li>
                <strong>Timeline</strong>
                <p>
                    The EcoFlow DELTA Pro 3 product campaign runs from June 11, 2024 to July 23, 2024 PST, with the official launch date being June 24, 8 PM
                    PST.
                </p>
            </li>
            <li>
                <strong>Early Bird Subscription</strong>
                <p>
                    To receive the latest information about EcoFlow DELTA Pro 3, you can enter your email address on the new product page between June 11 and
                    June 24 PST. By doing so, you agree to our email marketing terms and conditions and subscribe to our marketing emails for notifications.
                </p>
            </li>
            <li>
                <strong>Benefits</strong>
                <p>During the promotion period (June 11, 2024 to June 24, 2024 PST), you will get the following benefits by subscribing:</p>
                <ol className="ol-char">
                    <li>
                        Benefit 1: During the official launch period (June 24, 2024 to July 23 2024 PST), you will get a $500 coupon code: DP3LAUNCH that is
                        only available for DELTA Pro 3 portable power station stand-alone unit and enjoy the discount by applying the coupon at checkout. Only
                        one code can be applied to one transaction.
                    </li>
                    <li>
                        Benefit 2: During the official launch period (June 24, 2024 to July 23 2024 PST), you will get an extra $300 off discount on DELTA Pro 3
                        + DELTA Pro 3 Extra Battery bundle or DELTA Pro 3 + Transfer Switch bundle respectively, and get an extra $500 off discount on DELTA Pro
                        3+ Smart Home Panel 2 bundle by checking out at a discounted price directly.
                    </li>
                    <p>*Only one code can be applied to one transaction. These Benefits cannot combined with other discounts.</p>
                    <p>*Please keep the coupon information confidential and do not share the coupon with others.</p>
                    <p>
                        *EcoFlow reserves the right to cancel the coupon and any associated orders at any time in cases of dishonesty, fraud, or any violation
                        of these terms.
                    </p>
                </ol>
            </li>
            <li>
                <strong>Extended warranty service</strong>
                <p>
                    During the official launch period (June 24, 2024 to July 23, 2024 PST), when you purchase and successfully pay for the order of DELTA Pro 3
                    and related bundles, you will get a 7-year free warranty: 5 years standard warranty plus an additional 2 years extended warranty.
                </p>
                <p>*This extended warranty is only valid on DELTA Pro 3 and DELTA Pro 3-related bundles.</p>
            </li>
            <li>
                The Sale is open to all users on{' '}
                <a href="https://ca.ecoflow.com/" target="_blank" rel="noreferrer">
                    ca.ecoflow.com
                </a>{' '}
                who are Canadian citizens or residents and (i) at least 18 years of age or (ii) legal age before July 24, 2024 PST to form a binding contract
                with EcoFlow.
            </li>
            <li>
                Free gifts cannot be redeemed for cash or discounts. The free gifts are non-stackable, non-transferable, non-replaceable, non-discountable,
                non-selectable and non-upgradeable.
            </li>
            <li>Orders placed during the EcoFlow DELTA Pro 3 product campaign are refunded subject to the actual amount paid.</li>
            <li>When users request a refund of an order with free gifts, the gifts must be returned together. Otherwise, the refund can not be processed.</li>
            <li>
                You can cancel your order before shipping for a refund. Click{' '}
                <a href="https://ca.ecoflow.com/pages/return-refund-policy" target="_blank" rel="noreferrer">
                    here
                </a>{' '}
                for details about return and refund policies.
            </li>
            <li>
                Participants agree to release and discharge EcoFlow from any liabilities and claims, including breach of contract, tort, negligence, or any
                other cause of action at law or equity, arising out of, or in any way connected to this campaign or the participant's entry into the campaign.
            </li>
            <li>
                Participants further agree to release and discharge any third party related to or connected with this campaign from any liabilities and claims,
                including breach of contract, tort, negligence, or any other cause of action at law or equity arising out of, or in any way connected to this
                campaign, or the participant's entry into the campaign.
            </li>
            <li>
                By participating in this campaign, participants agree to indemnify and hold EcoFlow and the EcoFlow Group of Companies, their officers,
                directors, shareholders, predecessors, successors, employees, agents, and representatives harmless from any claims, losses, damages,
                liabilities, or expenses (including legal fees) arising from this campaign or related to it in any way.
            </li>
            <li>
                EcoFlow reserves the right to disqualify participants who use or have used improper means to participate in this campaign without prior notice
                and may initiate legal proceedings to the fullest extent permitted by applicable law.
            </li>
            <li>
                EcoFlow reserves the right to modify, adjust, or terminate this campaign, with any changes, adjustments, or terminations being announced on the
                online sales platform.
            </li>
            <li>
                Geographical Restrictions: This program is exclusive to the EcoFlow CA Online Store (
                <a href="https://ca.ecoflow.com/" target="_blank" rel="noreferrer">
                    ca.ecoflow.com
                </a>
                ).
            </li>
            <li>Separate Packaging: Products are shipped separately for safe delivery.</li>
            <li>
                If you have any questions, please contact customer service{' '}
                <a href="mailto:support@ecoflow.com" target="_blank" rel="noreferrer">
                    support@ecoflow.com
                </a>{' '}
                for assistance.
            </li>
            <li>This campaign and its terms and conditions are governed by the laws of the country where it is held.</li>
        </ol>
    </div>
);
const OPEN_SALE_US = () => (
    <div className="terms-list terms-open-sale">
        <ol className="ol-number">
            <li>
                <strong>Timeline</strong>
                <p>
                    The EcoFlow DELTA Pro 3 product campaign runs from June 11, 2024 to July 23, 2024 PST, with the official launch date being June 24, 8 PM
                    PST.
                </p>
            </li>
            <li>
                <strong>Early Bird Subscription</strong>
                <p>
                    To receive the latest information about EcoFlow DELTA Pro 3, you can enter your email address on the new product page between June 11th and
                    June 24th PST. By doing so, you agree to our email marketing terms and conditions and subscribe to our marketing emails for notifications.
                </p>
            </li>
            <li>
                <strong>Benefits</strong>
                <p>During the promotion period (June 11, 2024 to June 24, 2024 PST), you will get the following benefits by subscribing:</p>
                <ol className="ol-char">
                    <li>
                        Benefit 1: During the official launch period (June 24, 2024 to July 23 2024 PST), you will get a $500 coupon code: DP3LAUNCH that is
                        only available for DELTA Pro 3 portable power station stand-alone unit and enjoy the discount by applying the coupon at checkout. Only
                        one code can be applied to one transaction.
                    </li>
                    <li>
                        Benefit 2: During the official launch period (June 24, 2024 to July 23, 2024 PST), when you purchase a DELTA Pro 3 + 400W solar panel
                        bundle, we will only charge you for the price of the DELTA Pro 3, and the 400W solar panel will be included for free.
                    </li>
                    <li>
                        Benefit 3: During the official launch period (June 24, 2024 to July 23 2024 PST), you will get an extra $300 off discount on DELTA Pro 3
                        + DELTA Pro 3 Extra Battery, DELTA Pro 3+ Smart Home Panel 2 bundle or DELTA Pro 3 + Smart Generator 4000 (Dual Fuel) bundle
                        respectively, by checking out at a discounted price.
                    </li>
                </ol>
                <p>*Only one code can be applied to one transaction. These Benefits cannot combined with other discounts.</p>
                <p>*Please keep the coupon information confidential and do not share the coupon with others.</p>
                <p>
                    *EcoFlow reserves the right to cancel the coupon and any associated orders at any time in cases of dishonesty, fraud, or any violation of
                    these terms.
                </p>
            </li>
            <li>
                <strong>Upgraded Financing Option</strong>
                <p>
                    During June 24, 2024 to July 23, 2024 PST, orders with DELTA Pro 3 portable power station and the related bundles will get a 24-month
                    interest-free financing at 0% APR when you pay with Affirm, eligibility for this service is subject to Affirm's credit evaluation.
                </p>
            </li>
            <li>
                <strong>Membership Benefits</strong>
                <ol className="ol-char">
                    <li>
                        From July 3, 2024 to July 23, 2024 PST, only EcoFlow DELTA Pro 3-related products purchased on the official EcoFlow website (
                        <a href="https://us.ecoflow.com/" target="_blank" rel="noreferrer">
                            us.ecoflow.com
                        </a>
                        ) will receive double EcoCredits. DELTA Pro 3-related products include DELTA Pro 3 single units and DELTA Pro 3 bundles (which must
                        consist of DELTA Pro 3). No Membership Benefits will be available for purchasing other products.
                    </li>
                    <li>
                        The member's EcoCredits account must be logged in first and under the same email as the one used to place an order. Create a free
                        account here:{' '}
                        <a
                            className="break-all"
                            href="https://www.ecoflow.com/us/register?redirect=https://www.ecoflow.com/us/ecocredits"
                            onClick={() => {
                                signupCookie({
                                    sector_name: 'Terms & Conditions',
                                    entry_position: 8,
                                });
                            }}
                            target="_blank"
                            rel="noreferrer"
                        >
                            https://www.ecoflow.com/us/register?redirect=https://www.ecoflow.com/us/ecocredits
                        </a>
                        . All EcoCredits will be credited to the member's account once the order is shipped. If a return is initiated, EcoCredits will be
                        withdrawn.
                    </li>
                    <li>
                        EcoCredits can be used for cash deduction when purchasing designated products on the official EcoFlow website (
                        <a href="https://us.ecoflow.com/" target="_blank" rel="noreferrer">
                            us.ecoflow.com
                        </a>
                        ). For every 20 EcoCredits accumulated, members can reduce the order value by $1. The minimum number of EcoCredits required to apply for
                        a discount is 100. The maximum discount allowed per product is 5% of its total value.
                    </li>
                    <li>
                        The EcoCredits deduction will not apply to EcoFlow DELTA Pro 3 and related accessories and Flash Sale products and will not be stackable
                        with Extra Discount as defined above.
                    </li>
                </ol>
            </li>
            <li>
                <strong>Prime Day Sale Extra Discount</strong>
                <p>
                    Prime Day Exclusive Offer! Get extra discounts or freebies on DELTA Pro 3 bundles (standalone units excluded) plus extra EcoCredits! Find
                    out more on the{' '}
                    <a href="https://us.ecoflow.com/pages/prime-day" target="_blank" rel="noreferrer">
                        EcoFlow Prime Day Sale page.
                    </a>
                </p>
            </li>
            <li>
                <strong>Extended warranty service</strong>
                <p>
                    During the official launch period (June 24, 2024 to July 23, 2024 PST), when you purchase and successfully pay for the order of DELTA Pro 3
                    and related bundles, you will get a 7-year free warranty: 5 years standard warranty plus an additional 2 years extended warranty.
                </p>
                <p>*This extended warranty is only valid on DELTA Pro 3 and DELTA Pro 3-related bundles.</p>
            </li>
            <li>
                <strong>DELTA Pro 3 exclusive referral program</strong>
                <ol className="ol-char">
                    <li>
                        If a referrer successfully invites newly registered users on the official EcoFlow website (
                        <a href="https://us.ecoflow.com/" target="_blank" rel="noreferrer">
                            us.ecoflow.com
                        </a>
                        ), the referee will get 2000 EcoCredits and a $399 coupon. Applying this coupon at checkout can get a free PowerInsight Home Energy
                        Manager (value $399) with the purchase of a DELTA Pro 3 + PowerInsight Home Energy Monitor related bundles. And the referrer will get
                        300 EcoCredits, which <strong>will be capped at 9,000 EcoCredits per month</strong> ("Referral Program").
                    </li>
                    <li>Coupons received from the Referral Program can only be applied to DELTA Pro 3 + PowerInsight Home Energy Monitor related bundles.</li>
                    <li>
                        Coupons received from the Referral Program can be applied only once and cannot be used in conjunction with other discounts. The coupons
                        will expire on August 31, 2024 PST.
                    </li>
                    <li>
                        If a referee places an order within 30 days and the amount of the first order is not less than $299, the referrer will get a 5%
                        cashback. <strong>Cashback is capped at $250 per order.</strong>
                        <p>
                            (c) Please refer to more detailed terms and conditions of the EcoFlow Referral Program at{' '}
                            <a
                                className="break-all"
                                href="https://www.ecoflow.com/us/referral-delta-pro-3-portable-power-station"
                                target="_blank"
                                rel="noreferrer"
                            >
                                https://www.ecoflow.com/us/referral-delta-pro-3-portable-power-station
                            </a>
                        </p>
                    </li>
                </ol>
            </li>
            <li>
                The Sale is open to all users on{' '}
                <a href="https://us.ecoflow.com/" target="_blank" rel="noreferrer">
                    us.ecoflow.com
                </a>{' '}
                who are US citizens or residents and (i) at least 18 years of age or (ii) legal age before June 11, 2024 PST to form a binding contract with
                EcoFlow.
            </li>
            <li>
                Free gifts cannot be redeemed for cash or discounts. The free gifts are non-stackable, non-transferable, non-replaceable, non-discountable,
                non-selectable and non-upgradeable.
            </li>
            <li>Orders placed during the EcoFlow DELTA Pro 3 product campaign are refunded subject to the actual amount paid.</li>
            <li>When users request a refund of an order with free gifts, the gifts must be returned together. Otherwise, the refund can not be processed.</li>
            <li>
                You can cancel your order before shipping for a refund. Click{' '}
                <a href="https://us.ecoflow.com/pages/ecoflow-return-policy" target="_blank" rel="noreferrer">
                    here
                </a>{' '}
                for details about return and refund policies.
            </li>
            <li>
                Participants agree to release and discharge EcoFlow from any liabilities and claims, including breach of contract, tort, negligence, or any
                other cause of action at law or equity, arising out of, or in any way connected to this campaign or the participant's entry into the campaign.
            </li>
            <li>
                Participants further agree to release and discharge any third party related to or connected with this campaign from any liabilities and claims,
                including breach of contract, tort, negligence, or any other cause of action at law or equity arising out of, or in any way connected to this
                campaign, or the participant's entry into the campaign.
            </li>
            <li>
                By participating in this campaign, participants agree to indemnify and hold EcoFlow and the EcoFlow Group of Companies, their officers,
                directors, shareholders, predecessors, successors, employees, agents, and representatives harmless from any claims, losses, damages,
                liabilities, or expenses (including legal fees) arising from this campaign or related to it in any way.
            </li>
            <li>
                EcoFlow reserves the right to disqualify participants who use or have used improper means to participate in this campaign without prior notice
                and may initiate legal proceedings to the fullest extent permitted by applicable law.
            </li>
            <li>
                EcoFlow reserves the right to modify, adjust, or terminate this campaign, with any changes, adjustments, or terminations being announced on the
                online sales platform.
            </li>
            <li>
                Geographical Restrictions: This program is exclusive to the EcoFlow US Online Store (
                <a href="https://us.ecoflow.com/" target="_blank" rel="noreferrer">
                    us.ecoflow.com
                </a>
                ).
            </li>
            <li>Separate Packaging: Products are shipped separately for safe delivery.</li>
            <li>
                Free shipping is unavailable for outlying areas, including Guam, Puerto Rico, Hawaii, and Alaska. Please refer to our shipping policy for more
                details.
            </li>
            <li>
                If you have any questions, please contact customer service{' '}
                <a href="mailto:support@ecoflow.com" target="_blank" rel="noreferrer">
                    support@ecoflow.com
                </a>{' '}
                for assistance.
            </li>
            <li>This campaign and its terms and conditions are governed by the laws of the country where it is held.</li>
        </ol>
        <strong>Installation Consulting Service Terms and Conditions</strong>
        <ol className="ol-number">
            <li>
                <strong>Installation Conditions</strong>
                <ol className="ol-char">
                    <li>The Installation Consultation Package is issued upon the purchase of the EcoFlow Smart Home Panel 2 or Smart Home Panel 2 bundle.</li>
                    <li>
                        If a customer fails to fill out the installation information collection form sent via email by EcoFlow within 7 days upon receiving of
                        such email, rendering EcoFlow unable to collect information for matching electrician resources, it will be deemed that such customer
                        does not require installation/consultation services.
                    </li>
                </ol>
            </li>
            <li>
                <strong>Description of the Installation Consultation Package</strong>
                <ol className="ol-char">
                    <li>
                        In line with the promotion of EcoFlow Smart Home Panel 2 on the US EcoFlow official website (
                        <a href="https://www.ecoflow.com/us" target="_blank" rel="noreferrer">
                            https://www.ecoflow.com/us
                        </a>
                        ), EcoFlow will refer installation resources to customers who have placed orders and assist them in scheduling installation appointments
                        with electricians.
                    </li>
                    <li>
                        Installation consultation service includes wiring the EcoFlow Smart Home Panel 2 to the existing load center. It does not include wiring
                        the EcoFlow Power Station to solar panels or PV systems. If the customer requires the installation to include wiring to solar panels or
                        PV systems, the electrician reserves the right to refuse to take the order.
                    </li>
                    <li>The rebate is not applicable to the Hassel Free Kit.</li>
                    <li>
                        Information security related terms. The user's personal information is authorized by the user, and EcoFlow will not be held responsible
                        for any misuse of the user's information by electricians.
                    </li>
                </ol>
            </li>
            <li>
                <strong>Risk Statement of the Installation Consultation Package</strong>
                <ol className="ol-char">
                    <li>
                        Installation by electrician represents a commercial contract arrangement with contractual responsibilities exclusively between users and
                        electrician, exclusive of any contract or other responsibility of EcoFlow. Electrician assumes sole responsibility for its pricing
                        standards. EcoFlow shall be not liable for any of the consequences of electrician’s installation services.
                    </li>
                    <li>
                        There is a risk that the electrician will refuse to take orders in the current consultation and booking process.
                        <ol className="ol-lower-roman">
                            <li>
                                If, after purchasing an EcoFlow product, an electrician’s assessment concludes that the customer’s house condition does not
                                permit installation of EcoFlow Smart Home Panel 2 and a return is required, the cost incurred for the electrician’s on-site
                                assessment shall be borne by the customer.
                            </li>
                            <li>Modifications to Existing Rooftop Solar Systems Connections</li>
                            <li>
                                Home circuits that have been modified by customers without applying for applicable permissions from the government will not
                                satisfy EcoFlow products’ installation conditions.
                            </li>
                            <li>
                                If a customer’s house is too large to result in long wiring, rendering voltage value too low, there may be a risk that the NEC
                                regulations will not be satisfied, and installations will be unrealizable.
                            </li>
                            <li>Other circumstances that make installation impossible.</li>
                            <li>
                                EcoFlow will not be liable for any loss of personal property caused by voluntary installation by a customer if the above
                                installation conditions are not satisfied, and EcoFlow reserves the right of final interpretation.
                            </li>
                            <li>
                                The installation service does not include any cleaning or removal of debris generated during the installation process. Residents
                                are responsible for managing and disposing of all trash and debris resulting from the installation.
                            </li>
                            <li>
                                Any holes or modifications made to the premises during the installation are considered normal and necessary for the proper
                                completion of the service. The installer shall not be held liable for any unavoidable damages or alterations made to the
                                premises during the installation process.
                            </li>
                            <li>
                                Any additional costs arising from the need for extra materials or labor due to a complex installation environment shall be the
                                responsibility of the resident. These costs must be settled by the resident when completing the installation.
                            </li>
                            <li>
                                Any product issues or defects resulting from installation by an unauthorized installer shall be the sole responsibility of the
                                resident. The resident shall bear full responsibility for any after-sales service or repairs needed due to such unauthorized
                                installations.
                            </li>
                            <li>Privacy Protection</li>
                        </ol>
                        <p>
                            EcoFlow is only responsible for the user's personal information that we collect. EcoFlow is not responsible for any personal
                            information that the user authorizes to be given to electricians and shall not be held responsible for any misuse of the user's
                            information by electricians. To know more about your privacy rights and how EcoFlow handles your personal information, please view
                            our{' '}
                            <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank" rel="noreferrer">
                                Privacy Policy.
                            </a>
                        </p>
                    </li>
                </ol>
            </li>
        </ol>
        <strong>EcoFlow Smart Home Panel 2 (or Smart Home Panel 2 bundle) + Installation fee Installation Terms & Conditions</strong>
        <ol className="ol-number">
            <li>
                <strong>Installation Conditions</strong>
                <ol className="ol-char">
                    <li>
                        Home circuits that have been modified by customers without permission from the government will not meet the installation conditions.
                    </li>
                    <li>
                        If a customer's house is too large, resulting in excessive wiring and undervoltage, there may be a risk that the NEC regulations will
                        not be met, and the installation will be prevented.
                    </li>
                    <li>
                        In the event of unforeseen circumstances that may prevent installation, EcoFlow reserves the right to determine the final feasibility of
                        installation.
                    </li>
                    <li>
                        <strong>Description of the Installation Service Package</strong>
                        <ol className="ol-lower-roman">
                            <li>
                                To support sales of Smart Home Panel 2 or Smart Home Panel 2 bundle in North America through the EcoFlow US official website,
                                EcoFlow offers an installation service package, which includes the basic installation cost for Smart Home Panel 2.
                            </li>
                            <li>
                                Customers who purchase EcoFlow Smart Home Panel 2 or EcoFlow Smart Home Panel 2 bundle through Shopify may opt to purchase the
                                "Installation service Package" (limited to addresses in California, Texas, Florida, Washington, Illinois, Wisconsin, Minnesota,
                                Colorado, Indiana, Georgia, Nevada, Arizona, Michigan, Pennsylvania and NYC only). EcoFlow customer service is responsible for
                                matching the customers with electricians who can take the order and for following up on the progress of the installation.
                            </li>
                            <li>
                                Installation Service Package includes wiring the EcoFlow Smart Home Panel 2 to the existing load center. It does not include
                                wiring the EcoFlow Power Station to solar panels or PV systems. If the customer requires the installation to include wiring to
                                solar panels or PV systems, the electrician reserves the right to refuse to take the order. The installation service fee on the
                                official website covers labor costs and the materials needed for installing Smart Home Panel 2 within 2 feet of the load center.
                                This excludes:
                                <ol className="ol-number">
                                    <li>
                                        Additional material and labor costs due to excessive distance or incompatibility between the existing circuit breaker
                                        and Smart Home Panel 2.
                                    </li>
                                    <li>Permit application fees are incurred under applicable laws and regulations in certain areas.</li>
                                    <li>
                                        The electrician's on-site assessment fee can be waived if the circumstance has been assessed by the electrician to be
                                        suitable for installation and the customer does not request a refund of the installation service fee.
                                    </li>
                                </ol>
                                The above extra costs and fees shall be subject to the actual quote from the electrician. Customers are responsible for directly
                                paying the electrician for any extra costs incurred. EcoFlow reserves the right to final interpretation of the installation
                                service fee.
                            </li>
                            <li>
                                By agreeing to EcoFlow's installation services, you consent to the collection and processing of personal information necessary
                                for completing the service. This may include but is not limited to, your name, address, contact information, and any relevant
                                details related to the installation. We will handle your personal information in compliance with applicable data protection laws
                                and regulations and will only use it for the purpose of fulfilling the installation service. Please refrain from directly
                                providing your personal information to the electrician during the installation process, otherwise you will be responsible for
                                any loss or damage caused by the disclosure of such information.
                            </li>
                        </ol>
                    </li>
                </ol>
            </li>
            <li>
                <strong>Risk Statement of the Installation Service Package</strong>
                <ol className="ol-char">
                    <li>The option for the installation service package is based on the purchase of Smart Home Panel 2.</li>
                    <li>
                        If, after purchasing Smart Home Panel 2, it is concluded through the electrician's assessment that the customer's home situation does
                        not allow for installation of Smart Home Panel 2 and a return of Smart Home Panel 2 is necessary, the cost incurred for the
                        electrician's on-site assessment will be borne by the customer.
                    </li>
                    <li>
                        Should a customer opt for our installation service and then decide to return the Smart Home Panel 2 due to dissatisfaction after
                        installation, the paid installation fee cannot be refunded. Additionally, the customer will be responsible for any costs associated with
                        the removal of Smart Home Panel 2.
                    </li>
                </ol>
            </li>
        </ol>
    </div>
);
const OPEN_SALE_CA = () => (
    <div className="terms-list terms-open-sale">
        <ol className="ol-number">
            <li>
                <strong>Timeline</strong>
                <p>
                    The EcoFlow DELTA Pro 3 product campaign runs from June 11, 2024 to July 23, 2024 PST, with the official launch date being June 24, 8 PM
                    PST.
                </p>
            </li>
            <li>
                <strong>Early Bird Subscription</strong>
                <p>
                    To receive the latest information about EcoFlow DELTA Pro 3, you can enter your email address on the new product page between June 11 and
                    June 24 PST. By doing so, you agree to our email marketing terms and conditions and subscribe to our marketing emails for notifications.
                </p>
            </li>
            <li>
                <strong>Benefits</strong>
                <p>During the promotion period (June 11, 2024 to June 24, 2024 PST), you will get the following benefits by subscribing:</p>
                <ol className="ol-char">
                    <li>
                        Benefit 1: During the official launch period (June 24, 2024 to July 23 2024 PST), you will get a $500 coupon{' '}
                        <strong>code: DP3LAUNCH</strong> that is only available for DELTA Pro 3 portable power station stand-alone unit and enjoy the discount
                        by applying the coupon at checkout. Only one code can be applied to one transaction.
                    </li>
                    <li>
                        Benefit 2: During the official launch period (June 24, 2024 to July 23, 2024 PST), you will get an extra $300 off discount on DELTA Pro
                        3 + DELTA Pro 3 Extra Battery bundle or DELTA Pro 3 + Transfer Switch bundle respectively, and get an extra $500 off discount on DELTA
                        Pro 3+ Smart Home Panel 2 bundle by checking out at a discounted price directly.
                    </li>
                </ol>
                <p>*Only one code can be applied to one transaction. These Benefits cannot combined with other discounts.</p>
                <p>*Please keep the coupon information confidential and do not share the coupon with others.</p>
                <p>
                    *EcoFlow reserves the right to cancel the coupon and any associated orders at any time in cases of dishonesty, fraud, or any violation of
                    these terms.
                </p>
            </li>
            <li>
                <strong>Membership Benefits</strong>
                <ol className="ol-char">
                    <li>
                        From July 3, 2024 to July 23, 2024 PST, only EcoFlow DELTA Pro 3-related products purchased on the official EcoFlow website (
                        <a href="https://ca.ecoflow.com/" target="_blank" rel="noreferrer">
                            ca.ecoflow.com
                        </a>
                        ) will receive double EcoCredits. DELTA Pro 3-related products include DELTA Pro 3 single units and DELTA Pro 3 bundles (which must
                        include DELTA Pro 3). No Membership Benefits will be available for purchasing other products.
                    </li>
                    <li>
                        The member's EcoCredits account must be logged in first and under the same email as the one used to place an order. Create a free
                        account here:{' '}
                        <a
                            href="https://www.ecoflow.com/ca/register?redirect=https://www.ecoflow.com/ca/ecocredits"
                            target="_blank"
                            rel="noreferrer"
                            onClick={() => {
                                signupCookie({
                                    sector_name: 'Terms & Conditions',
                                    entry_position: 8,
                                });
                            }}
                        >
                            https://www.ecoflow.com/ca/register?redirect=https://www.ecoflow.com/ca/ecocredits
                        </a>
                        . All EcoCredits will be credited to the member's account once the order is shipped. If a return is initiated, EcoCredits will be
                        withdrawn.
                    </li>
                    <li>
                        EcoCredits can be used for cash deduction when purchasing designated products on the official EcoFlow website (
                        <a href="https://ca.ecoflow.com/" target="_blank" rel="noreferrer">
                            ca.ecoflow.com
                        </a>
                        ). For every 20 EcoCredits accumulated, members can reduce the order value by $1. The minimum number of EcoCredits required to apply for
                        a discount is 100. The maximum discount allowed per product is 5% of its total value.
                    </li>
                    <li>
                        The EcoCredits deduction will not apply to EcoFlow DELTA Pro 3 and related accessories and Flash Sale products and will not be stackable
                        with Extra Discount as defined above.
                    </li>
                </ol>
            </li>
            <li>
                <strong>Prime Day Sale Extra Discount</strong>
                <p>
                    Prime Day Exclusive Offer! Get extra discounts or freebies on DELTA Pro 3 bundles (standalone units excluded) plus extra EcoCredits! Find
                    out more on the{' '}
                    <a href="https://ca.ecoflow.com/pages/prime-day" target="_blank" rel="noreferrer">
                        EcoFlow Prime Day Sale page.
                    </a>
                </p>
            </li>
            <li>
                <strong>Extended warranty service</strong>
                <p>
                    During the official launch period (June 24, 2024 to July 23, 2024 PST), when you purchase and successfully pay for the order of DELTA Pro 3
                    and related bundles, you will get a 7-year free warranty: 5 years standard warranty plus an additional 2 years extended warranty.
                </p>
                <p>*This extended warranty is only valid on DELTA Pro 3 and DELTA Pro 3-related bundles.</p>
            </li>
            <li>
                <strong>DELTA Pro 3 exclusive referral program</strong>
                <ol className="ol-char">
                    <li>
                        If a referrer successfully invites new registered users on the official EcoFlow website (
                        <a href="https://ca.ecoflow.com/" target="_blank" rel="noreferrer">
                            ca.ecoflow.com
                        </a>
                        ), the referree will get 2000 EcoCredits and a $499 off coupon. Applying this coupon at checkout, you can get a free PowerInsight Home
                        Energy Manager (value $499) with the purchase of DELTA Pro 3 + PowerInsight Home Energy Manager related bundles. And the referrer will
                        get 300 EcoCredits, which
                        <strong> will be capped at 9,000 EcoCredits per month</strong> ("Referral Program").
                    </li>
                    <li>Coupons received from the Referral Program can only be applied to DELTA Pro 3 + PowerInsight Home Energy Manager related bundles.</li>
                    <li>
                        Coupons received from the Referral Program can be applied only once and cannot be used in conjunction with other discounts. The coupons
                        will expire on August 31, 2024 PST.
                    </li>
                    <li>
                        If a referee places an order within 30 days and the amount of the first order is not less than $299, the referrer will get a 5%
                        cashback. <strong>Cashback is capped at $250 per order.</strong>
                    </li>
                    <li>
                        Please refer to more detailed terms and conditions of the EcoFlow Referral Program at{' '}
                        <a href="https://www.ecoflow.com/ca/referral-delta-pro-3-portable-power-station" target="_blank" rel="noreferrer">
                            https://www.ecoflow.com/ca/referral-delta-pro-3-portable-power-station
                        </a>
                    </li>
                </ol>
            </li>
            <li>
                The Sale is open to all users on{' '}
                <a href="https://ca.ecoflow.com/" target="_blank" rel="noreferrer">
                    ca.ecoflow.com
                </a>{' '}
                who are Canadian citizens or residents and (i) at least 18 years of age or (ii) legal age before July 24, 2024 PST to form a binding contract
                with EcoFlow.
            </li>
            <li>
                Free gifts cannot be redeemed for cash or discounts. The free gifts are non-stackable, non-transferable, non-replaceable, non-discountable,
                non-selectable, and non-upgradeable.
            </li>
            <li>Orders placed during the EcoFlow DELTA Pro 3 product campaign are refunded subject to the actual amount paid.</li>
            <li>When users request a refund of an order with free gifts, the gifts must be returned together. Otherwise, the refund can not be processed.</li>
            <li>
                You can cancel your order before shipping for a refund. Click{' '}
                <a href="https://ca.ecoflow.com/pages/return-refund-policy" target="_blank" rel="noreferrer">
                    here
                </a>{' '}
                for details about return and refund policies.
            </li>
            <li>
                Participants agree to release and discharge EcoFlow from any liabilities and claims, including breach of contract, tort, negligence, or any
                other cause of action at law or equity, arising out of, or in any way connected to this campaign or the participant's entry into the campaign.
            </li>
            <li>
                Participants further agree to release and discharge any third party related to or connected with this campaign from any liabilities and claims,
                including breach of contract, tort, negligence, or any other cause of action at law or equity arising out of, or in any way connected to this
                campaign, or the participant's entry into the campaign.
            </li>
            <li>
                By participating in this campaign, participants agree to indemnify and hold EcoFlow and the EcoFlow Group of Companies, their officers,
                directors, shareholders, predecessors, successors, employees, agents, and representatives harmless from any claims, losses, damages,
                liabilities, or expenses (including legal fees) arising from this campaign or related to it in any way.
            </li>
            <li>
                EcoFlow reserves the right to disqualify participants who use or have used improper means to participate in this campaign without prior notice
                and may initiate legal proceedings to the fullest extent permitted by applicable law.
            </li>
            <li>
                EcoFlow reserves the right to modify, adjust, or terminate this campaign, with any changes, adjustments, or terminations being announced on the
                online sales platform.
            </li>
            <li>
                Geographical Restrictions: This program is exclusive to the EcoFlow CA Online Store (
                <a href="https://ca.ecoflow.com/" target="_blank" rel="noreferrer">
                    ca.ecoflow.com
                </a>
                ).
            </li>
            <li>Separate Packaging: Products are shipped separately for safe delivery.</li>
            <li>
                If you have any questions, please contact customer service{' '}
                <a href="mailto:support@ecoflow.com" target="_blank" rel="noreferrer">
                    support@ecoflow.com
                </a>{' '}
                for assistance.
            </li>
            <li>This campaign and its terms and conditions are governed by the laws of the country where it is held.</li>
        </ol>
    </div>
);
const EXTENDED_SALE_US = () => (
    <div className="terms-list terms-extended-sale">
        <strong>Installation Consulting Service Terms and Conditions</strong>
        <ol className="ol-number">
            <li>
                <strong>Installation Conditions</strong>
                <ol className="ol-char">
                    <li>The Installation Consultation Package is issued upon the purchase of the EcoFlow Smart Home Panel 2 or Smart Home Panel 2 bundle.</li>
                    <li>
                        If a customer fails to fill out the installation information collection form sent via email by EcoFlow within 7 days upon receiving of
                        such email, rendering EcoFlow unable to collect information for matching electrician resources, it will be deemed that such customer
                        does not require installation/consultation services.
                    </li>
                </ol>
            </li>
            <li>
                <strong>Description of the Installation Consultation Package</strong>
                <ol className="ol-char">
                    <li>
                        In line with the promotion of EcoFlow Smart Home Panel 2 on the US EcoFlow official website (
                        <a href="https://www.ecoflow.com/us" target="_blank" rel="noreferrer">
                            https://www.ecoflow.com/us
                        </a>
                        ), EcoFlow will refer installation resources to customers who have placed orders and assist them in scheduling installation appointments
                        with electricians.
                    </li>
                    <li>
                        Installation consultation service includes wiring the EcoFlow Smart Home Panel 2 to the existing load center. It does not include wiring
                        the EcoFlow Power Station to solar panels or PV systems. If the customer requires the installation to include wiring to solar panels or
                        PV systems, the electrician reserves the right to refuse to take the order.
                    </li>
                    <li>The rebate is not applicable to the Hassel Free Kit.</li>
                    <li>
                        Information security related terms. The user's personal information is authorized by the user, and EcoFlow will not be held responsible
                        for any misuse of the user's information by electricians.
                    </li>
                </ol>
            </li>
            <li>
                <strong>Risk Statement of the Installation Consultation Package</strong>
                <ol className="ol-char">
                    <li>
                        Installation by electrician represents a commercial contract arrangement with contractual responsibilities exclusively between users and
                        electrician, exclusive of any contract or other responsibility of EcoFlow. Electrician assumes sole responsibility for its pricing
                        standards. EcoFlow shall be not liable for any of the consequences of electrician’s installation services.
                    </li>
                    <li>
                        There is a risk that the electrician will refuse to take orders in the current consultation and booking process.
                        <ol className="ol-lower-roman">
                            <li>
                                If, after purchasing an EcoFlow product, an electrician’s assessment concludes that the customer’s house condition does not
                                permit installation of EcoFlow Smart Home Panel 2 and a return is required, the cost incurred for the electrician’s on-site
                                assessment shall be borne by the customer.
                            </li>
                            <li>Modifications to Existing Rooftop Solar Systems Connections</li>
                            <li>
                                Home circuits that have been modified by customer without applying for applicable permissions from government will not satisfy
                                EcoFlow products’ installation conditions.
                            </li>
                            <li>
                                If a customer’s house is too large to result in long wiring, rendering voltage value too low, there may be a risk that the NEC
                                regulations will not be satisfied, and installations will be unrealizable.
                            </li>
                            <li>Other circumstances that make installation impossible.</li>
                            <li>
                                EcoFlow will not be liable for any loss of personal property caused by voluntary installation by a customer if the above
                                installation conditions are not satisfied, and EcoFlow reserves the right of final interpretation.
                            </li>
                            <li>
                                The installation service does not include any cleaning or removal of debris generated during the installation process. Residents
                                are responsible for managing and disposing of all trash and debris resulting from the installation.
                            </li>
                            <li>
                                Any holes or modifications made to the premises during the installation are considered normal and necessary for the proper
                                completion of the service. The installer shall not be held liable for any unavoidable damages or alterations made to the
                                premises during the installation process.
                            </li>
                            <li>
                                Any additional costs arising from the need for extra materials or labor due to a complex installation environment shall be the
                                responsibility of the resident. These costs must be settled by the resident when completing the installation.
                            </li>
                            <li>
                                Any product issues or defects resulting from installation by an unauthorized installer shall be the sole responsibility of the
                                resident. The resident shall bear full responsibility for any after-sales service or repairs needed due to such unauthorized
                                installations.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Information security-related provisions: EcoFlow shall not be liable for any misuse of customer’s personal information
                        <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank" rel="noreferrer">
                            {' '}
                            (authorized by the user){' '}
                        </a>
                        by electricians.
                    </li>
                </ol>
            </li>
        </ol>
        <br />
        <strong>EcoFlow Smart Home Panel 2 (or Smart Home Panel 2 bundle) + Installation fee Installation Terms & Conditions</strong>
        <ol className="ol-number">
            <li>
                <strong>Installation Conditions</strong>
                <ol className="ol-char">
                    <li>
                        Home circuits that have been modified by customers without permission from the government will not meet the installation conditions.
                    </li>
                    <li>
                        If a customer's house is too large, resulting in excessive wiring and undervoltage, there may be a risk that the NEC regulations will
                        not be met, and the installation will be prevented.
                    </li>
                    <li>
                        In the event of unforeseen circumstances that may prevent installation, EcoFlow reserves the right to determine the final feasibility of
                        installation.
                    </li>
                    <li>
                        <strong>Description of the Installation Service Package</strong>
                        <ol className="ol-lower-roman">
                            <li>
                                To support sales of Smart Home Panel 2 or Smart Home Panel 2 bundle in North America through the EcoFlow US official website,
                                EcoFlow offers an installation service package, which includes the basic installation cost for Smart Home Panel 2.
                            </li>
                            <li>
                                Customers who purchase EcoFlow Smart Home Panel 2 or EcoFlow Smart Home Panel 2 bundle through Shopify may opt to purchase the
                                "Installation service Package" (limited to addresses in California, Texas, Florida, Washington, Illinois, Wisconsin, Minnesota,
                                Colorado, Indiana, Georgia, Nevada, Arizona, Michigan, Pennsylvania and NYC only). EcoFlow customer service is responsible for
                                matching the customers with electricians who can take the order and for following up on the progress of the installation.
                            </li>
                            <li>
                                Installation Service Package includes wiring the EcoFlow Smart Home Panel 2 to the existing load center. It does not include
                                wiring the EcoFlow Power Station to solar panels or PV systems. If the customer requires the installation to include wiring to
                                solar panels or PV systems, the electrician reserves the right to refuse to take the order. The installation service fee on the
                                official website covers labor costs and the materials needed for installing Smart Home Panel 2 within 2 feet of the load center.
                                This excludes:
                                <ol className="ol-number">
                                    <li>
                                        Additional material and labor costs due to excessive distance or incompatibility between the existing circuit breaker
                                        and Smart Home Panel 2.
                                    </li>
                                    <li>Permit application fees are incurred under applicable laws and regulations in certain areas.</li>
                                    <li>
                                        The electrician's on-site assessment fee can be waived if the circumstance has been assessed by the electrician to be
                                        suitable for installation and the customer does not request a refund of the installation service fee.
                                    </li>
                                </ol>
                                The above extra costs and fees shall be subject to the actual quote from the electrician. Customers are responsible for directly
                                paying the electrician for any extra costs incurred. EcoFlow reserves the right to final interpretation of the installation
                                service fee.
                            </li>
                            <li>
                                By agreeing to EcoFlow's installation services, you consent to the collection and processing of personal information necessary
                                for completing the service. This may include but is not limited to, your name, address, contact information, and any relevant
                                details related to the installation. We will handle your personal information in compliance with applicable data protection laws
                                and regulations and will only use it for the purpose of fulfilling the installation service. Please refrain from directly
                                providing your personal information to the electrician during the installation process, otherwise you will be responsible for
                                any loss or damage caused by the disclosure of such information.
                            </li>
                        </ol>
                    </li>
                </ol>
            </li>
            <li>
                <strong>Risk Statement of the Installation Service Package</strong>
                <ol className="ol-char">
                    <li>The option for the installation service package is based on the purchase of Smart Home Panel 2.</li>
                    <li>
                        If, after purchasing Smart Home Panel 2, it is concluded through the electrician's assessment that the customer's home situation does
                        not allow for installation of Smart Home Panel 2 and a return of Smart Home Panel 2 is necessary, the cost incurred for the
                        electrician's on-site assessment will be borne by the customer.
                    </li>
                    <li>
                        Should a customer opt for our installation service and then decide to return the Smart Home Panel 2 due to dissatisfaction after
                        installation, the paid installation fee cannot be refunded. Additionally, the customer will be responsible for any costs associated with
                        the removal of Smart Home Panel 2.
                    </li>
                    <li>
                        The installation service does not include any cleaning or removal of debris generated during the installation process. Residents are
                        responsible for managing and disposing of all trash and debris resulting from the installation.
                    </li>
                    <li>
                        Any holes or modifications made to the premises during the installation are considered normal and necessary for the proper completion of
                        the service. The installer shall not be held liable for any unavoidable damages or alterations made to the premises during the
                        installation process.
                    </li>
                    <li>
                        Any additional costs arising from the need for extra materials or labor due to a complex installation environment shall be the
                        responsibility of the resident. These costs must be settled by the resident when completing the installation.
                    </li>
                    <li>
                        Any product issues or defects resulting from installation by an unauthorized installer shall be the sole responsibility of the resident.
                        The resident shall bear full responsibility for any after-sales service or repairs needed due to such unauthorized installations.
                    </li>
                </ol>
            </li>
        </ol>
    </div>
);
const EXTENDED_SALE_CA = () => (
    <div className="terms-list terms-extended-sale">
        <ol className="ol-number">
            <li>
                <strong>Timeline</strong>
                <p>The EcoFlow DELTA Pro 3 product campaign runs from July 24, 2024 to August 31, 2024 PST.</p>
            </li>
            <li>
                <strong>Benefits</strong>
                <p>From July 24, 2024 to August 31, 2024 PST, you will get the following benefits:</p>
                <ol className="ol-char">
                    <li>
                        Benefit 1: You will get a $500 coupon <strong>code: DP3LAUNCH</strong> that is only available for DELTA Pro 3 portable power station
                        stand-alone unit and enjoy the discount by applying the coupon at checkout. Only one code can be applied to one transaction.
                    </li>
                    <li>
                        Benefit 2: You will get an extra $300 discount on DELTA Pro 3 + DELTA Pro 3 Extra Battery bundle or DELTA Pro 3 + Transfer Switch
                        bundle, respectively, and get an extra $500 discount on DELTA Pro 3+ Smart Home Panel 2 bundle by checking out at a discounted price
                        directly.
                    </li>
                </ol>
                <p>*Only one code can be applied to one transaction. These Benefits cannot combined with other discounts.</p>
                <p>*Please keep the coupon information confidential and do not share the coupon with others.</p>
                <p>
                    *EcoFlow reserves the right to cancel the coupon and any associated orders at any time in cases of dishonesty, fraud, or any violation of
                    these terms.
                </p>
            </li>
            <li>
                <strong>Delta Pro 3 exclusive referral program</strong>
                <ol className="ol-char">
                    <li>
                        If a referrer successfully invites new registered users on the official EcoFlow website (
                        <a href="https://ca.ecoflow.com/" target="_blank" rel="noreferrer">
                            ca.ecoflow.com
                        </a>
                        ), the referree will get 2000 EcoCredits and a $499 off coupon. Applying this coupon at checkout, you can get a free PowerInsight Home
                        Energy Manager (value $499) with the purchase of a DELTA Pro 3 + PowerInsight Home Energy Manager related bundles. And the referrer will
                        get 300 EcoCredits, which <strong>will be capped at 9,000 EcoCredits per month</strong> ("Referral Program").
                    </li>
                    <li>Coupons received from the Referral Program can be only applied on DELTA Pro 3 + PowerInsight Home Energy Manager related bundles.</li>
                    <li>
                        Coupons received from the Referral Program can be applied only once and cannot be used in conjunction with other discounts. The coupons
                        will expire on August 31, 2024 PST.
                    </li>
                    <li>
                        If a referee places an order within 30 days and the amount of the first order is not less than $299, the referrer will get a 5%
                        cashback. <strong>Cashback is capped at $250 per order.</strong>
                    </li>
                    <li>
                        Please refer to more detailed terms and conditions of the EcoFlow Referral Program at{' '}
                        <a href="https://www.ecoflow.com/ca/referral-delta-pro-3-portable-power-station" target="_blank" rel="noreferrer">
                            https://www.ecoflow.com/ca/referral-delta-pro-3-portable-power-station
                        </a>
                    </li>
                </ol>
            </li>
            <li>
                The Sale is open to all users on{' '}
                <a href="https://ca.ecoflow.com/" target="_blank" rel="noreferrer">
                    ca.ecoflow.com
                </a>{' '}
                who are Canadian citizens or residents and (i) at least 18 years of age or (ii) legal age before July 24, 2024 PST to form a binding contract
                with EcoFlow.
            </li>
            <li>
                Free gifts cannot be redeemed for cash or discounts. The free gifts are non-stackable, non-transferable, non-replaceable, non-discountable,
                non-selectable and non-upgradeable.
            </li>
            <li>Orders placed during the EcoFlow DELTA Pro 3 product campaign are refunded subject to the actual amount paid.</li>
            <li>When users request a refund of an order with free gifts, the gifts must be returned together. Otherwise, the refund can not be processed.</li>
            <li>
                You can cancel your order before shipping for a refund. Click{' '}
                <a href="https://ca.ecoflow.com/pages/return-refund-policy" target="_blank" rel="noreferrer">
                    here
                </a>{' '}
                for details about return and refund policies.
            </li>
            <li>
                Participants agree to release and discharge EcoFlow from any liabilities and claims, including breach of contract, tort, negligence, or any
                other cause of action at law or equity, arising out of, or in any way connected to this campaign or the participant's entry into the campaign.
            </li>
            <li>
                Participants further agree to release and discharge any third party related to or connected with this campaign from any liabilities and claims,
                including breach of contract, tort, negligence, or any other cause of action at law or equity arising out of, or in any way connected to this
                campaign, or the participant's entry into the campaign.
            </li>
            <li>
                By participating in this campaign, participants agree to indemnify and hold EcoFlow and the EcoFlow Group of Companies, their officers,
                directors, shareholders, predecessors, successors, employees, agents, and representatives harmless from any claims, losses, damages,
                liabilities, or expenses (including legal fees) arising from this campaign or related to it in any way.
            </li>
            <li>
                EcoFlow reserves the right to disqualify participants who use or have used improper means to participate in this campaign without prior notice
                and may initiate legal proceedings to the fullest extent permitted by applicable law.
            </li>
            <li>
                EcoFlow reserves the right to modify, adjust, or terminate this campaign, with any changes, adjustments, or terminations being announced on the
                online sales platform.
            </li>
            <li>
                Geographical Restrictions: This program is exclusive to the EcoFlow CA Online Store (
                <a href="https://ca.ecoflow.com/" target="_blank" rel="noreferrer">
                    ca.ecoflow.com
                </a>
                ).
            </li>
            <li>Separate Packaging: Products are shipped separately for safe delivery.</li>
            <li>
                If you have any questions, please contact customer service{' '}
                <a href="mailto:support@ecoflow.com" target="_blank" rel="noreferrer">
                    support@ecoflow.com
                </a>{' '}
                for assistance.
            </li>
            <li>This campaign and its terms and conditions are governed by the laws of the country where it is held.</li>
        </ol>
    </div>
);

const TheComp: FC = () => {
    const { locale = 'us', query } = useRouter();
    const { pageStatus } = useDP3Store();
    const { time } = query;
    const CURRENT_TIME = time ? new Date(time.toString()) : new Date();
    const WARM_UP_TIME = new Date('2024/06/11 15:00:00 GMT+8');
    const OPEN_SALE_TIME = new Date('2024/06/25 11:00:00 GMT+8');
    const EXTENDED_SALE_TIME = new Date('2024/07/24 15:00:00 GMT+8');
    const END_TIME = new Date('2024/08/31 11:00:00 GMT+8');
    const { t } = useLang('dp3.teaser.FooterTips');

    const listNa = [
        {
            title: 'title1',
        },
        {
            title: 'title2',
        },
        {
            title: 'title3',
        },
        {
            title: 'title4',
        },
        {
            title: 'title5',
            className: 'item-textindex-r',
        },
        {
            title: 'title6',
            className: 'item-textindex-r',
        },
        {
            title: 'title7',
            className: 'item-textindex-r',
        },
        {
            title: 'title8',
        },
        {
            title: 'title9',
        },
        {
            title: 'title10',
        },
        {
            title: 'title11',
            email: 'mailto:support@ecoflow.com',
        },
        {
            title: 'title12',
            link: ['br'].includes(locale) ? 'https://br.ecoflow.com/pages/return-refund-policy' : `https://${locale}.ecoflow.com/pages/ecoflow-return-policy`,
        },
        {
            title: 'title13',
        },
        {
            title: 'title14',
        },
        {
            title: 'title15',
        },
    ];
    const listJP = [
        {
            title: 'title1',
            className: 'item-bottom-teaser',
        },
        {
            title: 'title2',
            className: 'item-bottom-teaser',
        },
        {
            title: 'title3',
            className: 'item-bottom-line1',
        },
        {
            title: 'title4',
            className: 'item-header-line1',
        },
        {
            title: 'title5',
        },
        {
            title: 'title6',
            link: 'https://jp.ecoflow.com/pages/price-guarantee-delta-pro-3',
        },
        {
            title: 'title7',
        },
        {
            title: 'title8',
        },
        {
            title: 'title9',
        },
        {
            title: 'title10',
            email: 'mailto:support.jp@ecoflow.com',
        },
        {
            title: 'title11',
            link: 'https://jp.ecoflow.com/pages/warranty-policy',
        },
        {
            title: 'title12',
            link: 'https://jp.ecoflow.com/pages/online-store-policy',
        },
        {
            title: 'title_a_h',
            className: 'item-header-line1 no-bottom big-group',
        },
        // {
        //     title: 'title_b_h',
        //     className: 'item-header-line1 item-header-mt20',
        // },
        {
            title: 'title_c_h',
            className: 'item-header-line1 no-bottom',
        },
        {
            title: 'title_c_1',
            email: 'mailto:deltapro3@ecoflow.com',
        },
        {
            title: 'title_c_2',
        },
        {
            title: 'title_c_3',
        },
        {
            title: 'title_d_h',
            className: 'item-header-line1 no-bottom',
        },
        {
            title: 'title_d_1',
        },
        {
            title: 'title_e_h',
            className: 'item-header-line1 no-bottom',
        },
        {
            title: 'title_e_1',
        },
        {
            title: 'title_e_2',
        },
        {
            title: 'title_e_3',
        },
        {
            title: 'title_e_4',
        },
        {
            title: 'title_e_5',
        },
        {
            title: 'title_e_6',
        },
        {
            title: 'title_f_h',
            className: 'item-header-line1 no-bottom',
        },
        {
            title: 'title_f_1',
        },
        {
            title: 'title_g_h',
            className: 'item-header-line1  no-bottom',
        },
        {
            title: 'title_k_h',
            className: 'item-header-line1 item-header-mt20 big-group',
        },
        {
            title: 'title_k_1',
        },
        {
            title: 'title_k_2',
        },
        {
            title: 'title_k_3',
        },
        {
            title: 'title_k_4',
        },
        {
            title: 'title_k_5',
        },
    ];
    const listCN = [
        {
            title: 'title1',
        },
        {
            title: 'title2',
        },
        {
            title: 'title3',
        },
        {
            title: 'title4',
        },
        {
            title: 'title5',
        },
        {
            title: 'title6',
        },
        {
            title: 'title7',
        },
        {
            title: 'title8',
        },
        {
            title: 'title9',
        },
    ];
    const listA = locale === 'jp' ? listJP : locale === 'cn' ? listCN : listNa;

    const CommonTerms = () => (
        <>
            {listA.map((item: any, index: number) => (
                <div className={`comp-item ${item.className ? item.className : ''}`} key={index}>
                    {t.rich(item.title, {
                        link: (text: string) => (
                            <a className="comp-item-link" href={item.link} target="_blank" rel="noreferrer">
                                {text}
                            </a>
                        ),
                        email: (text: string) => (
                            <a className="comp-item-email" href={item.email}>
                                {text}
                            </a>
                        ),
                    })}
                </div>
            ))}
        </>
    );

    let Terms = CommonTerms();
    if (locale === 'us') {
        Terms = EXTENDED_SALE_US();
        // if (CURRENT_TIME > EXTENDED_SALE_TIME && CURRENT_TIME < END_TIME) {
        //     Terms = EXTENDED_SALE_US();
        // } else if (pageStatus === IPageStatus.statusA) {
        //     Terms = WARM_UP_US();
        // } else if (pageStatus === IPageStatus.statusB) {
        //     Terms = OPEN_SALE_US();
        // }
    } else if (locale === 'ca') {
        if (CURRENT_TIME > EXTENDED_SALE_TIME && CURRENT_TIME < END_TIME) {
            Terms = EXTENDED_SALE_CA();
        } else if (pageStatus === IPageStatus.statusA) {
            Terms = WARM_UP_CA();
        } else if (pageStatus === IPageStatus.statusB) {
            Terms = OPEN_SALE_CA();
        }
    }

    return locale === 'ca' ? (
        ''
    ) : (
        <div className={`${css.thecomp}`}>
            <div className={`comp-list comp-status-${pageStatus}`}>
                {/* <p className="comp-item">{t('title')}</p> */}
                {Terms}
            </div>
        </div>
    );
};

export default TheComp;
